import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { Button, Container, Form, FormGroup, Input, Label, ModalBody, Row } from 'reactstrap';
import './styles.css';

import * as ROUTES from '../../constants/routes';
import { doPasswordReset } from '../../firebase/api/auth';
import { IS_SIDEKICK_APP } from '../../constants/projects';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [successSend, setSuccessSendStatus] = useState(false);
    const [error, setError] = useState(null);

    const isInvalid = email === '';

    const history = useHistory();

    const handleBackButtonClick = useCallback(() => {
        history.push(ROUTES.SIGN_IN);
    }, [history]);

    const handleEmailChange = useCallback(e => {
        setEmail(e.target.value);
    }, []);

    const handleSubmit = useCallback(
        event => {
            event.preventDefault();

            doPasswordReset(email)
                .then(() => {
                    setSuccessSendStatus(true);
                })
                .catch(error => {
                    setError(error);
                });
        },
        [email]
    );

    return (
        <div
            className={classNames('unauthorized-forgot-password__container', {
                'unauthorized-forgot-password__container--sidekick': IS_SIDEKICK_APP,
            })}
        >
            <Container>
                <Row className="unauthorized-forgot-password">
                    <div className="unauthorized-forgot-password__popup">
                        <div className="unauthorized-forgot-password__popup-title">
                            Forgot Password
                        </div>
                        <div className="text-center">
                            {successSend ? (
                                <p>Check your email</p>
                            ) : (
                                <p>
                                    Enter your email address. We'll email you instructions to reset
                                    your password.
                                </p>
                            )}
                        </div>

                        <Form action="" method="post" name="login" onSubmit={handleSubmit}>
                            <FormGroup>
                                <Label for="exampleEmail">Email address</Label>
                                <Input
                                    type="email"
                                    name="email"
                                    onChange={handleEmailChange}
                                    id="exampleEmail"
                                    placeholder="Enter Email"
                                />
                            </FormGroup>
                            <div className="submit-button d-flex justify-content-between">
                                <Button
                                    className="forgot"
                                    outline
                                    color="primary"
                                    style={{ width: '35%' }}
                                    onClick={handleBackButtonClick}
                                >
                                    Back
                                </Button>
                                <Button
                                    type="submit"
                                    color="primary"
                                    disabled={isInvalid || successSend}
                                    className="submit"
                                    style={{ width: '60%' }}
                                >
                                    Reset Password
                                </Button>
                            </div>
                            {error && <p>{error.message}</p>}
                        </Form>
                    </div>
                </Row>
            </Container>
        </div>
    );
};

ForgotPassword.propTypes = {};

export default React.memo(ForgotPassword);
